import { useState } from "react"
import RecordsSelect, { SelectAllLink } from "../records-select"
import TeamFilter from "../filters/team-filter"
import { map } from "lodash"
import { useMembersGroupsQuery } from "@timenotes/shared/src/services/members-groups/queries/use-members-groups-query"
import { useUsersAccountsForFiltersQuery } from "@timenotes/shared/src/services/users-accounts/queries/use-users-accounts-for-filters-query"
import { TApiTaskAssignee, TApiUsersAccount } from "@timenotes/shared/src/services/api-client/types"

interface Props extends Omit<React.ComponentProps<typeof RecordsSelect<TApiTaskAssignee[]>>, 'options' | 'valueProp' | 'labelProp' | 'searchProp'> {
  filters?: {
    projectId?: string
  }
}

// CHANGED TO HAVE ID inside!
const membersToOptions = (
  members: { id: string; firstName: string; lastName: string; hashId: string }[]
) => {
  return map(members, (member) => {
    return {
      value: {
        name: `${member.firstName} ${member.lastName}`,
        id: member.id,
        hashId: member.hashId,
        taskId: 'MISSING!',
        type: 'UsersAccount',
      },
    }
  })
}

// COPY-PASTE OF TEAM FILTER
export const AssigneesSelect = (props: Props) => {
  const {
    value,
    onChange,
    onBlur,
    autoFocus,
    filters,
  } = props

  const [showInactive, setShowInactive] = useState(false)

  const membersGroupsQuery = useMembersGroupsQuery({
    perPage: 1000,
    filters: filters,
  })
 
  const groups = membersGroupsQuery.data?.membersGroups || []

  const usersAccountsQuery = useUsersAccountsForFiltersQuery({
    perPage: 1000,
    filters: filters,
  })
  const members = (usersAccountsQuery.data?.usersAccounts ||
    []) as TApiUsersAccount[]
  const inactiveMembersOptions = usersAccountsQuery.data?.inactiveOptions

  const membersOptions = membersToOptions(members.filter((m) => !!m.active))

  const groupsOptions = map(groups, (group) => {
    return {
      value: {
        name: group.name,
        id: group.id,
        type: 'MembersGroup',
        hashId: group.hashId,
        taskId: 'MISSIING!!!',
      },
    }
  })

  const handleOnChange = (items: TApiTaskAssignee[]): void => {
    if (!onChange) {
      return
    }
    onChange(items, <></>)
  }

  const isLoading = usersAccountsQuery.isLoading || membersGroupsQuery.isLoading
  const selectedCount = value ? value.length : 0

  const inactiveUsersOption = !showInactive
    ? {
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>{inactiveMembersOptions?.length} Inactive members hidden</div>
            <div>
              <SelectAllLink onClick={() => setShowInactive(true)}>
                Add to search
              </SelectAllLink>
            </div>
          </div>
        ),
        options: [],
      }
    : {
        label: "Inactive members",
        options: membersToOptions(
          (inactiveMembersOptions || []).map(
            (option) => option.value
          ) as TApiUsersAccount[]
        ),
      }

  const usersOption = !usersAccountsQuery.data?.usersAccounts
    ? []
    : [
        {
          label: "Members",
          allFilters: true,
          options: membersOptions,
        },
      ]

  const groupsOption = !membersGroupsQuery.data?.membersGroups
    ? []
    : [
        {
          label: "Groups",
          allFilters: true,
          options: groupsOptions,
        },
      ]

  const allOptions = [
    ...usersOption,
    ...groupsOption,
    ...((inactiveMembersOptions || []).length > 0 ? [inactiveUsersOption] : []),
  ]

  const selectedItems = allOptions
    .flatMap((optionGroup) => optionGroup.options)
    .flatMap((option) => option.value)
    .filter((userOrGroup) => {
      const selectedAssigneeIds = value?.map((r) => r.id)

      return (selectedAssigneeIds || []).includes(userOrGroup.id)
    })

  return (
    <div onClick={(e) => e.stopPropagation()} >
      <RecordsSelect<TApiTaskAssignee>
        {...props}
        open={true}
        loading={isLoading}
        disabled={isLoading}

        /*
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            hide && hide()
          }
        }}
        */

        style={{
          width: "300px",
          zIndex: "300",
        }}
        valueProp={"id"}
        labelProp="name"
        searchProp="name"
        placeholder="Member or Group"
        showSearch={true}
        mode="multiple"
        options={allOptions}
        onChange={handleOnChange}
        onBlur={onBlur}
        value={selectedItems as any}
        autoFocus={autoFocus}
        dropdownMatchSelectWidth={true}
        getPopupContainer={(node) => {
          return node
        }}
        filterInputMode={true}
      />
    </div>
  )
}

export default TeamFilter
